import React, { useEffect } from "react";
import { zodResolver } from "@hookform/resolvers/zod";

import { z } from "zod";
import { useForm } from "react-hook-form";
import { branchSchema } from "@/utils/schemaHelper";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/uiComponents/components/ui/form";
import { Input } from "@/uiComponents/components/ui/input";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/enums/routes";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@/store/store";
import { setLoading } from "@/store/redux/appSlice";
import { getBranchApi, updateBranchApi } from "@/modules/organizationServices";

import {
  setBranches,
  updatedBranch,
} from "@/store/redux/organization/branchSlice";

import { updateBranchProps } from "@/types/organization";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/uiComponents/components/ui/dialog";
import { ErrorHelper } from "@/utils/errorHelper";
import { BranchError } from "@/enums/errorMessages";
import { toastMessage } from "@/utils/toastHelper";
import { ReusableButton } from "@/reusable/reusableButton";

const UpdateBranch: React.FC<updateBranchProps> = ({
  onClose,
  isOpen,
  branch,
}) => {
  if (!isOpen) return null;
  const dispatch = useDispatch();

  const loading = useSelector((state: RootState) => state.app.loading);
  const userDetais = useSelector(
    (state: RootState) => state.userDetail.userDetail,
  );
  const orgId = userDetais?.organizationId;
  const role = useSelector((state: RootState) => state.userDetail.role);

  const navigate = useNavigate();
  const form = useForm<z.infer<typeof branchSchema>>({
    resolver: zodResolver(branchSchema),
    mode: "onChange",
    defaultValues: {
      branchName: branch.branchName,
    },
  });

  useEffect(() => {
    if (!role.isSuperAdmin && !role.isOrgAdmin) {
      navigate(ROUTES.BRANCHES);
    }
  }, [role]);

  const getBranches = async () => {
    try {
      if (!orgId) return;
      const res = await getBranchApi(orgId);
      const response = res.branches;
      if (response !== undefined) {
        const branches = Array.isArray(response) ? response : [response];
        dispatch(setBranches(branches));
      }
    } catch (error) {
      const actualError = ErrorHelper(error);
      const message = Array.isArray(actualError) ? actualError[0] : actualError;
      toastMessage("error", message);
    }
  };

  const onSubmit = async (values: z.infer<typeof branchSchema>) => {
    if (loading) return;
    dispatch(setLoading(true));

    try {
      if (!branch.id) {
        throw new Error(BranchError.BRANCH_ID_REQUIRED);
        toastMessage("error", BranchError.BRANCH_ID_REQUIRED);
      }

      await updateBranchApi(values, branch.id, role);
      getBranches();
      dispatch(
        updatedBranch({
          id: branch.id,
          ...values,
        }),
      );

      onClose();

      toastMessage("success", BranchError.BRANCH_UPDATED);
    } catch (error) {
      const actualError = ErrorHelper(error);
      const message = Array.isArray(actualError) ? actualError[0] : actualError;
      toastMessage("error", message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Edit Branch</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8 ">
            <div className="min-h-6 mb-1"></div>
            <FormField
              control={form.control}
              name="branchName"
              render={({ field }) => (
                <FormItem className="max-h-13 ">
                  <FormLabel>Branch Name</FormLabel>

                  <FormControl>
                    <Input className="bg-white" {...field} />
                  </FormControl>
                </FormItem>
              )}
            />

            <div className="flex justify-center mt-4 mr-2">
              <ReusableButton
                label="Update"
                className=" mt-5 mb-2 "
                loading={loading}
              />
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
export default UpdateBranch;
